import { useGetCropMixComposerSettings, useListSoilSightScenarios, useUserContext } from "utils";

export type AgronomistSignals = {
  /** the farm has at least one SoilSight scenario; undefined until the list has answered */
  hasScenarios: boolean | undefined;
  /** the farm has at least one saved cover crop mix; undefined until the list has answered */
  hasSavedMix: boolean | undefined;
};

type AgronomistSignalsOptions = {
  /** the SoilSight card renders, so its button and its place-to-start tag need the scenario list */
  loadScenarios: boolean;
  /** the Cover Crop Mixer card renders, so its place-to-start tag needs the saved mixes */
  loadMixes: boolean;
};

/** whether a list has entries; undefined until it has answered */
const hasAny = (items: unknown[] | undefined): boolean | undefined => (items ? items.length > 0 : undefined);

/** The farm data behind the agronomist cards; a hidden card's request stays off. */
export const useAgronomistSignals = ({ loadScenarios, loadMixes }: AgronomistSignalsOptions): AgronomistSignals => {
  const { user } = useUserContext();
  const soilSightProjectId = user?.farm?.soilSightProjectId ?? "";
  const { data: scenarios } = useListSoilSightScenarios(soilSightProjectId, { enabled: loadScenarios });
  const { data: mixes } = useGetCropMixComposerSettings({ enabled: loadMixes });

  return {
    // a farm without a SoilSight project has no scenarios, and its list is never requested
    hasScenarios: soilSightProjectId ? hasAny(scenarios) : false,
    hasSavedMix: hasAny(mixes),
  };
};
